import { HttpClient } from "@angular/common/http";
import { APP_BASE_HREF } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";

import { HttpServiceBase, OperationError } from "@indusoft/angular-base-services";

import { ConfigurationHttpService } from "../../common/services/configuration.service";
import { RoutesGlossary } from "../../common/glossary/routes-glossary";
import { GetLicenseInfoResponse } from "./dtos/license-info-get-response";

@Injectable()
export class LicenseHttpService extends HttpServiceBase {
    protected serviceUrl: string;

    constructor(http: HttpClient,
        @Inject(APP_BASE_HREF) public baseHref: string,
        private config: ConfigurationHttpService) {
        super(http);
    }

    public getLicenseInfo(): Observable<GetLicenseInfoResponse> {
        const url = this.config.getFullUrl(RoutesGlossary.GetLicenseInfo);

        return this.httpGet<GetLicenseInfoResponse>(url, '')
            .pipe(map(response => {
                if (response instanceof OperationError)
                    throw new Error(response.message);
                return response;
            }));
    }
}
